(function () {

  function replaceSocialLinks() {

    // Facebook
    document.querySelectorAll('a.beae-share-link.facebook').forEach(function(link) {
      link.removeAttribute('href');

      link.setAttribute('href', 'https://www.facebook.com/PierDeco/');
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });


    // Pinterest
    document.querySelectorAll('a.beae-share-link.pinterest').forEach(function(link) {
      link.removeAttribute('href');

      link.setAttribute('href', 'https://pin.it/353G8shy7');
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

  }


  // Run immediately
  replaceSocialLinks();


  // Run again when the page is ready
  document.addEventListener('DOMContentLoaded', replaceSocialLinks);


  // Beae may dynamically recreate the elements,
  // so watch for changes and replace the links again.
  const observer = new MutationObserver(function() {
    replaceSocialLinks();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "66e320079ef1f59a4c015542";
              window.beaePageSetting.pageTitle = "Contact"; 
              window.beaePageSetting.pageType = "page";

          let js_LGDV9I4N = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-17j2hgiasection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-17j2hgia',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-17j2hgia');
        args.el = args.els[0];
        ((data) => { var t;if((t=data.el.querySelector(".beae-grid-system"))==null||t.addEventListener("scroll",o=>{var r,n;let a=o.target;if(!a.classList.contains("beae-grid-carousel"))return;let s=Math.round((a.scrollLeft+a.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(a.offsetWidth*.8))+1;(r=data.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(n=data.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||n.classList.add("active")}),data.mode.value=="live"){const videoContainer=data.el.querySelector('.beae-section-background-video[data-device="desktop"]'),videoMobileContainer=data.el.querySelector('.beae-section-background-video[data-device="mobile"]'),initVideoBackground=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(videoContainer){let options={};if(data.optionsVideo)try{eval("options = "+data.optionsVideo)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoContainer);rs&&(videoContainer.innerHTML=rs.html,initVideoBackground.push("desktop"))}}else if(videoMobileContainer){let options={};if(data.optionsVideoMobile)try{eval("options = "+data.optionsVideoMobile)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoMobileContainer);rs&&(videoMobileContainer.innerHTML=rs.html,initVideoBackground.push("mobile"))}}(videoContainer||videoMobileContainer)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!initVideoBackground.includes("desktop")&&window.innerWidth>=768&&videoContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo,videoContainer);o&&(videoContainer.innerHTML=o.html,initVideoBackground.push("desktop"))}if(!initVideoBackground.includes("mobile")&&window.innerWidth<768&&videoMobileContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile,videoMobileContainer);o&&(videoMobileContainer.innerHTML=o.html,initVideoBackground.push("mobile"))}}})}data.el.querySelectorAll(".beae-text-highlight").forEach(o=>{new IntersectionObserver((s,r)=>{s.forEach(n=>{n.isIntersecting&&(n.target.querySelectorAll("path, line").forEach(l=>{l.style.strokeDasharray=parseFloat(l.getAttribute("data-dash-ratio")*n.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(n.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(o)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-17j2hgia: ', ex)
      };
    

      try {
        let argid = 'beae-daoqvhn2block-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-daoqvhn2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-daoqvhn2');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-daoqvhn2: ', ex)
      };
    

      try {
        let argid = 'beae-7533gvgxblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7533gvgx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7533gvgx');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7533gvgx: ', ex)
      };
    

      try {
        let argid = 'beae-e232yzpablock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-e232yzpa',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-e232yzpa');
        args.el = args.els[0];
        ((_) => { if(_.el){let w,k=_.autoHover;var b=_.el.querySelector(".beae-img-ratio-control"),v=_.el.querySelector(".beae-img-comp-container"),y=_.el.querySelector(".beae-img-comp-container--second");if(b&&y){let g=function(C){let x=0,L,S,$;B(),k?_.el.onmouseover=function(P){V(P)}:C.onmousedown=function(P){V(P)},_.el.onmouseup=function(){M()},C.ontouchstart=function(P){V(P)},_.el.ontouchend=function(){M()};function B(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{w=y.offsetWidth})}).observe(y),C.style.left&&(S=parseInt(C.style.left))}function V(P){check=!1,P.preventDefault(),P.clientX?L=P.clientX:L=P.touches[0].clientX,x=1,_.el.onmousemove=function(H){T(H)},_.el.ontouchmove=function(H){T(H)}}function M(){x=0,isNaN($)||(S=$),check=!0}function T(P){if(x==0||k&&!(P.target==y||P.target==_.el.querySelector(".beae-image-secondary")))return!1;$=E(P),$<0&&($=0),$>100&&($=100),O($)}function E(P){P=P.changedTouches?P.changedTouches[0]:P;let H;return k?H=Math.round(P.offsetX*100/w):H=Math.round(S-(L-P.pageX)*100/w),H}function O(P){C.style.left=P+"%",y.style.clipPath=`polygon(${P}% 0%, ${P}% 100%, 100% 100%, 100% 0)`,v.style.clipPath=`polygon(0% 100%, 0% 0%, ${P}% 0%, ${P}% 100%)`}};b&&y&&g(b),window.addEventListener("resize",function(){b&&y&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{w=y.offsetWidth})}).observe(y),g(b))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-e232yzpa: ', ex)
      };
    

      try {
        let argid = 'beae-mdzfovqeblock-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mdzfovqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mdzfovqe');
        args.el = args.els[0];
        ((data
) => { const fields = data.el.querySelectorAll('.beae-form-field');

if(fields && fields.length) { 
    fields.forEach(field => {
        const input = field.querySelector('input[type="text"], input[type="email"], textarea');
        if(input) {
            input.addEventListener('focus', function() {
                const fieldForcus = data.el.querySelector('.beae-form-field.focus');
                if(fieldForcus) {
                    fieldForcus.classList.remove('focus')
                }
                field.classList.add('focus');
            });
        }
    })
} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mdzfovqe: ', ex)
      };
    

      try {
        let argid = 'beae-mdzfovqeblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mdzfovqe',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mdzfovqe');
        args.el = args.els[0];
        ((f) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,_=f.el.querySelector("form");f.el.querySelector(".beae-btn-pr");const b=f.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),v=f.el.querySelector(".btn-lightbox-form > a");!h&&f.mode.value!=="builder"&&(f.el.querySelector(".beae-form-success-message").style="display: none"),h&&f.afterSubmitting=="redirect"&&f.redirect&&(window.location.href=f.redirect);const y=[];_&&_.addEventListener("submit",w=>{w.preventDefault();for(let k=0;k<b.length;k++)y.push({fieldKey:b[k].name,fieldType:b[k].type,fieldValue:b[k].value})}),v&&(v.onclick=()=>{const w=document.createElement("div");w.innerHTML=_.outerHTML||"",window.BeaePopupLibrary.createPopup(w,{layout:"center",layoutMobile:"bottom",width:"500px"})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mdzfovqe: ', ex)
      };
    

      try {
        let argid = 'beae-1b2x7mf7section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1b2x7mf7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1b2x7mf7');
        args.el = args.els[0];
        ((data) => { var t;if((t=data.el.querySelector(".beae-grid-system"))==null||t.addEventListener("scroll",o=>{var r,n;let a=o.target;if(!a.classList.contains("beae-grid-carousel"))return;let s=Math.round((a.scrollLeft+a.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(a.offsetWidth*.8))+1;(r=data.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(n=data.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||n.classList.add("active")}),data.mode.value=="live"){const videoContainer=data.el.querySelector('.beae-section-background-video[data-device="desktop"]'),videoMobileContainer=data.el.querySelector('.beae-section-background-video[data-device="mobile"]'),initVideoBackground=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(videoContainer){let options={};if(data.optionsVideo)try{eval("options = "+data.optionsVideo)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoContainer);rs&&(videoContainer.innerHTML=rs.html,initVideoBackground.push("desktop"))}}else if(videoMobileContainer){let options={};if(data.optionsVideoMobile)try{eval("options = "+data.optionsVideoMobile)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoMobileContainer);rs&&(videoMobileContainer.innerHTML=rs.html,initVideoBackground.push("mobile"))}}(videoContainer||videoMobileContainer)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!initVideoBackground.includes("desktop")&&window.innerWidth>=768&&videoContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo,videoContainer);o&&(videoContainer.innerHTML=o.html,initVideoBackground.push("desktop"))}if(!initVideoBackground.includes("mobile")&&window.innerWidth<768&&videoMobileContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile,videoMobileContainer);o&&(videoMobileContainer.innerHTML=o.html,initVideoBackground.push("mobile"))}}})}data.el.querySelectorAll(".beae-text-highlight").forEach(o=>{new IntersectionObserver((s,r)=>{s.forEach(n=>{n.isIntersecting&&(n.target.querySelectorAll("path, line").forEach(l=>{l.style.strokeDasharray=parseFloat(l.getAttribute("data-dash-ratio")*n.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(n.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(o)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1b2x7mf7: ', ex)
      };
    

      try {
        let argid = 'beae-fmf2jnemblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fmf2jnem',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fmf2jnem');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fmf2jnem: ', ex)
      };
    

      try {
        let argid = 'beae-a5xkl57dblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-a5xkl57d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-a5xkl57d');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-a5xkl57d: ', ex)
      };
    

      try {
        let argid = 'beae-66549l97block-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-66549l97',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-66549l97');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-66549l97: ', ex)
      };
    

      try {
        let argid = 'beae-fiytu0h0block-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fiytu0h0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fiytu0h0');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fiytu0h0: ', ex)
      };
    

      try {
        let argid = 'beae-sem98yb8block-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sem98yb8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sem98yb8');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sem98yb8: ', ex)
      };
    

      try {
        let argid = 'beae-ebf11ulsblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ebf11uls',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ebf11uls');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ebf11uls: ', ex)
      };
    

      try {
        let argid = 'beae-fhabyc9kblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fhabyc9k',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fhabyc9k');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fhabyc9k: ', ex)
      };
    

      try {
        let argid = 'beae-nw3ay2ysblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nw3ay2ys',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nw3ay2ys');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nw3ay2ys: ', ex)
      };
    

      try {
        let argid = 'beae-sghobxspblock-share',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sghobxsp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sghobxsp');
        args.el = args.els[0];
        ((c) => { const l=window.location.href;if(c.type=="label_with_icon"){if(c.mode.value=="live"){let u=function(f){switch(f){case"facebook":return"https://www.facebook.com/sharer/sharer.php?u=";case"twitter":return"https://twitter.com/intent/tweet?url=";case"linkedIn":return"https://www.linkedin.com/shareArticle?mini=true&url=";case"pinterest":return"https://pinterest.com/pin/create/button/?url=";case"reddit":return"https://reddit.com/submit?url=";case"skype":return"https://web.skype.com/share?url=";case"telegram":return"https://t.me/share/url?url=";case"whatsApp":return"https://api.whatsapp.com/send/?phone&text=";case"email":return"mailto:?&subject=&cc=&bcc=&body=";default:return"#"}};const m=c.el.querySelectorAll(".beae-share-link");m.length>0&&m.forEach((f,h)=>{let _=f.getAttribute("type"),b="";b=u(_)+l,f.setAttribute("href",b)})}}else if(c.type=="copy_link"){const u=c.el.querySelector(".beae-share-wrp");u.onclick=()=>{window.navigator.clipboard.writeText(l),d()}}else{const u=c.el.querySelector(".beae-share-wrp"),m=c.el.querySelector(".beae-share-link-copy-link");if(m&&(m.innerHTML=l),navigator.share)u.addEventListener("click",()=>{navigator.share({url:l,title:document.title})});else{const f=c.el.querySelector(".beae-share--container");c.el.querySelector(".beae-share-link-copy-btn").addEventListener("click",()=>{window.navigator.clipboard.writeText(l),d(),f.classList.remove("active")}),u.addEventListener("click",()=>{f.classList.toggle("active")}),document.addEventListener("click",function(_){f.contains(_.target)||f.classList.remove("active")})}}function d(){const u=c.el.querySelector(".beae-share--toast");u&&(u.classList.add("active"),setTimeout(()=>{u.classList.remove("active")},1e3))} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sghobxsp: ', ex)
      };
    }; if (window.BEAEBASE) {js_LGDV9I4N()} else {window.BEAEPAGEJS.push(js_LGDV9I4N)} })(); (function () {

  function replaceSocialLinks() {

    // Facebook
    document.querySelectorAll('a.beae-share-link.facebook').forEach(function(link) {
      link.removeAttribute('href');

      link.setAttribute('href', 'https://www.facebook.com/PierDeco/');
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });


    // Pinterest
    document.querySelectorAll('a.beae-share-link.pinterest').forEach(function(link) {
      link.removeAttribute('href');

      link.setAttribute('href', 'https://pin.it/353G8shy7');
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

  }


  // Run immediately
  replaceSocialLinks();


  // Run again when the page is ready
  document.addEventListener('DOMContentLoaded', replaceSocialLinks);


  // Beae may dynamically recreate the elements,
  // so watch for changes and replace the links again.
  const observer = new MutationObserver(function() {
    replaceSocialLinks();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();